import { DropdownItem } from '@factorialco/f0-react/dist/experimental'
import { IntegrationsSyncableStateStatusEnum } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import { GroupedStatus, groupedStatuses } from 'modules/integrations/lib/syncableStatus'

const translatedGroupedStatus = (groupedStatus: GroupedStatus): string => {
  if (groupedStatus === 'syncing') return i18n.t('integrations.sync_tooltips.syncing')
  if (groupedStatus === 'pending') return i18n.t('integrations.sync_tooltips.pending')
  if (groupedStatus === 'outdated') return i18n.t('integrations.sync_tooltips.outdated')
  if (groupedStatus === 'partially_synced')
    return i18n.t('integrations.sync_tooltips.partially_synced')
  if (groupedStatus === 'failed') return i18n.t('integrations.sync_tooltips.failed')
  if (groupedStatus === 'synced') return i18n.t('integrations.sync_tooltips.synced')

  throw new Error(`Unknown grouped status: ${groupedStatus}`)
}

export const statusesItems = (
  statusesGroups: Set<IntegrationsSyncableStateStatusEnum>[]
): DropdownItem[] => {
  const items: DropdownItem[] = []

  groupedStatuses(statusesGroups)
    .reduce((map, groupedStatus) => {
      map.set(groupedStatus, (map.get(groupedStatus) ?? 0) + 1)
      return map
    }, new Map<GroupedStatus, number>())
    .forEach((value, key) => {
      if (key === 'syncing') return

      items.push({
        label: `${translatedGroupedStatus(key)}: ${value}`,
        critical: key === 'failed',
      })
    })

  return items
}
